import { render, staticRenderFns } from "./modal-editowner.vue?vue&type=template&id=a49cd25c&scoped=true&"
import script from "./modal-editowner.vue?vue&type=script&lang=js&"
export * from "./modal-editowner.vue?vue&type=script&lang=js&"
import style0 from "./modal-editowner.vue?vue&type=style&index=0&id=a49cd25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49cd25c",
  null
  
)

export default component.exports